import './shared/log-override'
require("@rails/ujs").start()
require("@rails/activestorage").start()
global.$ = require("jquery")
import('./shared/sjcl').then(value => global.sjcl = value)

import '@claviska/jquery-minicolors'
import '@claviska/jquery-minicolors/jquery.minicolors.css'

import 'bootstrap'
import $ from 'jquery'
import crypto from './shared/aion_crypto'
import './shared/detect_change'
import './shared/utils'
import '../stylesheets/backend.scss'

import './backend_vue.js'

import './backend/wysiwyg'
import './backend/sortable'
require("chartkick")
require("chart.js")

$(document).on('input', '#voter_election_code', function(){
  let electionCode = $(this).val()
  let privateKey = crypto.electionCodeToPrivateKey(electionCode)
  let publicKey = crypto.generateKeyPair(privateKey).public_key
  $('#voter_public_key').val(publicKey)
})

// for collapsible sidebar in slide edit view
import {CollapsibleSidebar} from "./backend/collapsible_sidebar";
$(function() {
  $('.collapse-horizontal').each(function () {
    this.collapsibleSidebar = new CollapsibleSidebar(this);
  })
})

// When an input is set inside an element with the data-exclusive="xyz" prop set, all other inputs inside an element
// with data-exclusive="xyz" will be disabled, except the ones in the same element as the source
$(function () {
  $('[data-exclusive]').each(function () {
    let groupName = $(this).data('exclusive')
    let groupElement = $(this)
    $(this).find(':input').on('blur', function () {
      let inputs = $(`[data-exclusive=${groupName}]`).find(':input:not(button):not([type=hidden])')
      let groupInputs = groupElement.find(':input:not(button):not([type=hidden])')
      if (groupInputs.is(function() {return this.value.length > 0 })) {
        inputs.prop('disabled', true)
        groupElement.find(':input').prop('disabled', false)
        inputs.filter('[disabled]').val('')
      } else {
        inputs.prop('disabled', false)
      }
    })
  })
})

$(document).on('change', '.custom-file-input', function(){
  let $label = $(this).next('.custom-file-label')

  let originalLabel = $label.data('original-label')
  if( originalLabel === undefined ){
    originalLabel = $label.html()
    $label.data('original-label', originalLabel)
  }

  console.log('originalLabel', originalLabel)

  let file = this.files[0]
  if( file ){
    $label.html(file.name)
  } else {
    $label.html(originalLabel)
  }
})

// makes popovers work
$(function () {
  $('[data-toggle="popover"]').popover()
})

// used in election config to select colors (attribute/_color.html.erb)
$(function(){
  $('.js-colorpicker').each((index, node) => {
    $(node).minicolors({
      theme: 'bootstrap',
      ...node.dataset
    })
  })
})

// used for preview images
$(function() {
  $('.js-preview-image').each(function(){
    let fieldName = $(this).find('.custom-file-input')[0].getAttribute('name')
    let fieldValue = $(this).find('.custom-file-label').text()
    if(!fieldValue.startsWith('/')) fieldValue = ""

    $(this).parent().prepend(`<input id="${fieldName}Hidden" value="" type="hidden" name="${fieldName.replace('[','[remove_')}" />`)
    $(this).append(`<div class="input-group-append">
              <a href="javascript:void(0)" id="${fieldName}Undo" class="btn btn-outline-secondary" style="display:none"><span class="fas fa-undo"></span> </a>
              <a href="javascript:void(0)" id="${fieldName}Remove" class="btn btn-danger disabled"><span class="fas fa-trash"></span> </a>
            </div>`)
    let preview = document.getElementById(fieldName + 'Preview');
    if(preview === null) {
      preview = $(`<img style="display: none" src="${fieldValue}" class="img-fluid" id="${fieldName}Preview">`)[0]
      $(this).parent().append(preview)
    }
    if(fieldValue !== "") {
      preview.style.display = 'block';
    }
    let input = $(this).find('.custom-file-input')[0];
    let hidden = document.getElementById(fieldName + 'Hidden');
    let remove = document.getElementById(fieldName + 'Remove');
    let undo = document.getElementById(fieldName + 'Undo');

    remove.classList.toggle('disabled', fieldValue === "")
    input.onchange = function (ev) {
      const file = ev.target.files[0];
      preview.src = URL.createObjectURL(file);
      preview.style.display = 'block';
      remove.classList.remove('disabled');
    }
    remove.onclick = function () {
      preview.style.opacity = 0.5;
      hidden.value = '1';
      undo.style.display = 'block';
      remove.style.display = 'none';
    };

    undo.onclick = function () {
      preview.style.opacity = 1;
      hidden.value = '';
      undo.style.display = 'none';
      remove.style.display = 'block';
    };
  })
})

// datetime picker for browsers that don't support input type="datetime-local"
import 'jquery-datetimepicker'
import 'jquery-datetimepicker/jquery.datetimepicker.css'
$(function() {
  $('input[type=datetime-local]').each(function(){
    if(this.type !== "datetime-local")
      $(this).datetimepicker({
        theme: 'bootstrap',
        step: 5,
        onChangeDateTime: function(_dateTime, $datePicker) {
          $datePicker[0].dispatchEvent(new Event('input'));
        }
      })
  })
})